import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-700 text-white p-4 text-center">
      <h1>Copyright Kay Rottmann 2024</h1>
    </footer>
  );
};

export default Footer;
